const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // 修改订单申报方式为正报
  update91 ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/jyorder/update91', params)
  },
  updateNeedCcSth ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/jyorder/update-need-cc-sth', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jyb/jyorder.js